export const iconFontAwesomeSecurityRoadSpikes = (
	<i className="fa-solid fa-road-spikes"></i>
);
